import { AssetType } from "../enums";
import { IAssetModel } from "../models";

export class DeepLinkHelper {
  static createDeepLinkUrl(asset: IAssetModel) {
    if (!asset.Id) {
      return null;
    }

    if (
      asset.AssetTypeCode === AssetType.Series ||
      asset.AssetTypeCode === AssetType.Season  ||
      asset.AssetTypeCode === AssetType.Program
    ) {
      return `${process.env.REACT_APP_DEEP_LINK_URL}/series-details/${asset.Id}`;
    }

    if ( asset.AssetTypeCode === AssetType.Channel ) {
      return `${process.env.REACT_APP_DEEP_LINK_URL}/channel/${asset.Id}`;
    }

    if (
      asset.AssetTypeCode === AssetType.Podcast ||
      asset.AssetTypeCode === AssetType.Album
    ) {
      return `${process.env.REACT_APP_DEEP_LINK_URL}/album-details/${asset.Id}`;
    }

    if (
      asset.AssetTypeCode === AssetType.Episode ||
      asset.AssetTypeCode === AssetType.Video ||
      asset.AssetTypeCode === AssetType.Live ||
      asset.AssetTypeCode === AssetType.Event
    ) {
      return `${process.env.REACT_APP_DEEP_LINK_URL}/movie-details/${asset.Id}`;
    }

    return `${process.env.REACT_APP_DEEP_LINK_URL}/movie-details/${asset.Id}`;
  }
}